import Stream from "mithril/stream";
const isValidForm = (fields) => {
    let hasErrors = false;
    const fieldnames = Object.keys(fields);
    for (let i = 0; i < fieldnames.length; i += 1) {
        const field = fields[fieldnames[i]];
        field.validate(field.value());
        hasErrors = field.complaint || hasErrors;
    }
    return !hasErrors;
};
const string = (required = true) => {
    const field = {
        complaint: "",
        value: Stream(""),
        validate: (input) => {
            field.complaint = "";
            if ((!input || !input.length) && required) {
                field.complaint = "is-empty";
            }
            field.value(input);
        },
    };
    return field;
};
const number = (required = true) => {
    const field = {
        complaint: undefined,
        value: Stream(""),
        validate: (input) => {
            field.complaint = undefined;
            if (input && !input.match(/^[0-9]+$/)) {
                return;
            }
            if ((!input || !input.length) && required) {
                field.complaint = "is-empty";
            }
            field.value(input);
        },
    };
    return field;
};
const zipCode = (required = true) => {
    const field = {
        complaint: undefined,
        value: Stream(""),
        validate: (input) => {
            field.complaint = undefined;
            if ((!input || !input.length) && required) {
                field.complaint = "is-empty";
            }
            field.value(input);
        },
    };
    return field;
};
const title = (required = true) => {
    const field = {
        complaint: undefined,
        value: Stream(""),
        validate: (input) => {
            field.complaint = undefined;
            if ((!input || !input.length) && required) {
                field.complaint = "is-empty";
            }
            else if (!["", "Dr.", "Prof."].includes(input)) {
                field.complaint = "is-invalid";
            }
            field.value(input);
        },
    };
    return field;
};
const fields = {
    customer: {
        zip: zipCode(),
        number: number(),
    },
    address: {
        city: string(),
        gender: string(),
        prename: string(),
        surname: string(),
        street: string(),
        houseNumber: string(),
        country: string(),
        zipCode: zipCode(),
        title: title(false),
        addressAddition: string(false),
    },
};
export { fields, isValidForm };
export default fields;
